import ToolbarButton from '../ToolbarButton';
import { LinkIcon } from '../icons';

export default function LinkButton({ handleDropdown, isActive }) {
  const handleToggleLinkPicker = () => {
    handleDropdown({ open: !isActive });
  };

  return (
    <ToolbarButton
      onClick={handleToggleLinkPicker}
      aria-label="editor-link"
      data-active={isActive}
    >
      <LinkIcon />
    </ToolbarButton>
  );
}
